import type { LexiconEntry } from './lexicon-schema.js'
import { LEXICON_ENTRIES } from './lexicon-entries.js'
import { BORROWED_LEXICON_ENTRIES } from './lexicon-borrowed-entries.js'

/**
 * Frozen map of all lexicon entries keyed by id. Built at module load from
 * `LEXICON_ENTRIES` (Phase-1 starter set: cadences/modes/progressions) plus
 * `BORROWED_LEXICON_ENTRIES` (borrowed-chord entries for S3b). New entries
 * should land in the appropriate sibling file so the polished starter set
 * stays attributable to its author.
 */
const ALL_ENTRIES: LexiconEntry[] = [...LEXICON_ENTRIES, ...BORROWED_LEXICON_ENTRIES]

export const LEXICON: Readonly<Record<string, LexiconEntry>> = Object.freeze(
  Object.fromEntries(ALL_ENTRIES.map(entry => [entry.id, entry]))
)

/**
 * Returns the lexicon entry for `id`, or null when the id is unknown. The
 * null return is deliberate: surfaces should gracefully hide the label rather
 * than render a placeholder when the analyzer emits an id the lexicon hasn't
 * shipped yet.
 */
export const getLexiconEntry = (id: string): LexiconEntry | null => LEXICON[id] ?? null
